// Email Obfuscation Mixin
// Provides obfuscated email addresses to protect from bots and scrapers

export default {
  computed: {
    // Obfuscated: info@apptolink.com
    infoEmail() {
      return String.fromCharCode(105,110,102,111,64,97,112,112,116,111,108,105,110,107,46,99,111,109);
    },
    infoMailto() {
      return 'mailto:' + this.infoEmail;
    },
    
    // Obfuscated: privacy@apptolink.com
    privacyEmail() {
      return String.fromCharCode(112,114,105,118,97,99,121,64,97,112,112,116,111,108,105,110,107,46,99,111,109);
    },
    privacyMailto() {
      return 'mailto:' + this.privacyEmail;
    }
  }
}

